<h2 mat-dialog-title>{{ "PASSENGERS.UPDATE.managePassenger" | translate }}</h2>
<mat-dialog-content class="mat-typography">
    <mat-tab-group mat-align-tabs="center" dynamicHeight [color]="'primary'" #tabGroup>
        <mat-tab [label]="'PASSENGERS.UPDATE.passengerInformations' | translate">
            <form #passengersForm="ngForm" fxFlex="100" (ngSubmit)="onFormSubmit()" [formGroup]="passengerFormGroup">
                <div fxLayout="column" fxLayout.gt-md="row wrap" fxLayoutGap="10px" class="mt-15">
                    <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "PASSENGERS.UPDATE.firstName" | translate }}</mat-label>
                        <input matInput [placeholder]="'PASSENGERS.UPDATE.firstName' | translate" name="firstName" formControlName="firstName" />
                        @if (passengerFormGroup.controls["firstName"].hasError("required")) {
                            <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "PASSENGERS.UPDATE.lastName" | translate }}</mat-label>
                        <input matInput [placeholder]="'PASSENGERS.UPDATE.lastName' | translate" name="lastName" formControlName="lastName" />
                        @if (passengerFormGroup.controls["lastName"].hasError("required")) {
                            <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "PASSENGERS.UPDATE.gender" | translate }}</mat-label>
                        <mat-select name="gender" formControlName="gender">
                            <mat-option value="M">
                                {{ "PASSENGERS.UPDATE.male" | translate }}
                            </mat-option>
                            <mat-option value="F">
                                {{ "PASSENGERS.UPDATE.female" | translate }}
                            </mat-option>
                            <mat-option value="K">
                                {{ "PASSENGERS.UPDATE.kid" | translate }}
                            </mat-option>
                            <mat-option value="I">
                                {{ "PASSENGERS.UPDATE.infant" | translate }}
                            </mat-option>
                        </mat-select>
                        @if (passengerFormGroup.controls["gender"].hasError("required")) {
                            <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "PASSENGERS.UPDATE.dateOfBirth" | translate }}</mat-label>
                        <input
                            matInput
                            [matDatepicker]="dateOfBirthPicker"
                            [placeholder]="'PASSENGERS.UPDATE.dateOfBirth' | translate"
                            name="dateOfBirth"
                            formControlName="dateOfBirth"
                            [max]="maxBirthDay"
                        />
                        <mat-datepicker-toggle matSuffix [for]="dateOfBirthPicker"> </mat-datepicker-toggle>
                        <mat-datepicker #dateOfBirthPicker></mat-datepicker>
                        @if (passengerFormGroup.controls["dateOfBirth"].hasError("matDatepickerParse")) {
                            <mat-error> {{ "GENERAL.invalidDateFormat" | translate }}</mat-error>
                        }
                        @if (passengerFormGroup.controls["dateOfBirth"].hasError("required")) {
                            <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                        }
                    </mat-form-field>
                </div>
                <div fxLayout="column" fxLayout.gt-sm="row" fxLayoutGap="10px" class="pt-15">
                    <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "PASSENGERS.UPDATE.idCardNumber" | translate }}</mat-label>
                        <input matInput [placeholder]="'PASSENGERS.UPDATE.idCardNumber' | translate" name="idCardNumber" formControlName="idCardNumber" />
                    </mat-form-field>
                    <mat-form-field fxFlex appearance="outline" [floatLabel]="'always'">
                        <mat-label>{{ "PASSENGERS.UPDATE.nationality" | translate }}</mat-label>
                        <mat-select name="nationalityId" formControlName="nationalityId">
                            @for (country of countries; track country) {
                                <mat-option [value]="country.id">
                                    {{ country.name }}
                                </mat-option>
                            }
                        </mat-select>
                        @if (passengerFormGroup.controls["nationalityId"].hasError("required")) {
                            <mat-error> {{ "GENERAL.required" | translate }}</mat-error>
                        }
                    </mat-form-field>
                </div>
            </form>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                @if (!imagePathF && !imagePathB) {
                    <mat-icon class="mr-5" style="color: red">close</mat-icon>
                }
                @if (imagePathF || imagePathB) {
                    <mat-icon class="mr-5" style="color: green">check</mat-icon>
                }
                {{ "PASSENGERS.UPDATE.idCardPicture" | translate }}
            </ng-template>
            <br />
            <br />
            <h4>
                {{ "PASSENGERS.idCardPictureLabel" | translate }}
            </h4>
            <div fxLayout="row" fxLayoutAlign="none" fxLayoutGap="20px" style="margin-top: 20px">
                <div>
                    <h4>{{ "PASSENGERS.idCardPictureFront" | translate }}</h4>
                    <div>
                        @if (imagePathF) {
                            <div style="text-align: center">
                                <img mat-card-image [src]="imagePathF" style="max-width: 50%; height: auto" alt="id card picture front" />
                            </div>
                        } @else {
                            <strong class="pt-10 pb-10" style="display: block; font-size: small"> {{ "PASSENGERS.UPDATE.missingPictureWarningMsg" | translate }} </strong>
                        }
                        @if (documentImageFront.hasError("wrongFileType")) {
                            <mat-error>
                                <strong class="p-10"> {{ "GENERAL.wrongFileType" | translate }} </strong>
                            </mat-error>
                        }
                        @if (documentImageFront.hasError("maxFileSize")) {
                            <mat-error>
                                <strong class="p-10"> {{ "GENERAL.maxFileSize" | translate }} </strong>
                            </mat-error>
                        }
                        <!-- <mat-error>
                <strong class="p-10">{{'PASSENGERS.UPDATE.imageRequiredErrorMsg' | translate}}</strong>
              </mat-error> -->
                    </div>
                    <div fxLayout="column" fxLayoutGap="10px">
                        @if (!imagePathF) {
                            <button fxFlex type="button" mat-raised-button color="accent" (click)="fileInputF.click()">
                                {{ "PASSENGERS.UPDATE.chooseFile" | translate }}
                            </button>
                        }
                        <input hidden #fileInputF type="file" (change)="handleImageFileInputF($event)" />
                        @if (imagePathF) {
                            <button fxFlex type="button" mat-raised-button color="warn" (click)="removeChoosenImage(0)">
                                {{ "PASSENGERS.UPDATE.removeChoosenFile" | translate }}
                            </button>
                        }
                    </div>
                </div>
                <div>
                    <h4>{{ "PASSENGERS.idCardPictureBack" | translate }}</h4>
                    <div>
                        @if (imagePathB) {
                            <div style="text-align: center">
                                <img mat-card-image [src]="imagePathB" style="max-width: 50%; height: auto" alt="id card picture back" />
                            </div>
                        } @else {
                            <strong class="pt-10 pb-10" style="display: block; font-size: small"> {{ "PASSENGERS.UPDATE.missingPictureWarningMsg" | translate }} </strong>
                        }
                        @if (documentImageBack.hasError("wrongFileType")) {
                            <mat-error>
                                <strong class="p-10"> {{ "GENERAL.wrongFileType" | translate }} </strong>
                            </mat-error>
                        }
                        @if (documentImageBack.hasError("maxFileSize")) {
                            <mat-error>
                                <strong class="p-10"> {{ "GENERAL.maxFileSize" | translate }} </strong>
                            </mat-error>
                        }
                        <!-- <mat-error>
              <strong class="p-10">{{'PASSENGERS.UPDATE.imageRequiredErrorMsg'
              | translate}}</strong>
            </mat-error> -->
                    </div>
                    <div fxLayout="column" fxLayoutGap="10px">
                        @if (!imagePathB) {
                            <button fxFlex type="button" mat-raised-button color="accent" (click)="fileInputB.click()">
                                {{ "PASSENGERS.UPDATE.chooseFile" | translate }}
                            </button>
                        }
                        <input hidden #fileInputB type="file" (change)="handleImageFileInputB($event)" />
                        @if (imagePathB) {
                            <button fxFlex type="button" mat-raised-button color="warn" (click)="removeChoosenImage(1)">
                                {{ "PASSENGERS.UPDATE.removeChoosenFile" | translate }}
                            </button>
                        }
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end">
    @if (createMode) {
        <section class="mr-15">
            <mat-checkbox class="mat-small" [(ngModel)]="addDNewPassengerCheck">{{ "PASSENGERS.UPDATE.addOtherPassenger" | translate }}</mat-checkbox>
        </section>
    }
    <button mat-raised-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>
        {{ "GENERAL.cancel" | translate }}
    </button>
    <button mat-raised-button color="primary" (click)="passengersForm.ngSubmit.emit()">
        {{ "GENERAL.save" | translate }}
    </button>
</mat-dialog-actions>
